<h4 class="fw-bold">
    {{ "government_scores.scopes.single" | translate }}
    <span class="fw-light mx-1">
        @if (displayLabel) {
            - {{ displayLabel }}
        }
    </span>
</h4>

<div class="bg-card shadow-md rounded p-2 mb-2" [formGroup]="scopeForm">
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-dropdown
                controlName="entityId"
                formControlName="entityId"
                [clearable]="true"
                [invalid]="submitted && scopeForm.get('entityId')?.invalid!"
                [label]="'common.form.label.entity' | translate"
                [setValidator]="formValidation()!"
                [options]="entities()"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-dropdown
                controlName="pillarId"
                formControlName="pillarId"
                [clearable]="true"
                [invalid]="submitted && scopeForm.get('pillarId')?.invalid!"
                [label]="'government_scores.pillars.pillar_type' | translate"
                [setValidator]="formValidation()!"
                [options]="pillars()"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="nameAE"
                formControlName="nameAE"
                [invalid]="submitted && scopeForm.get('nameAE')?.invalid!"
                [label]="'common.form.label.nameAE' | translate"
                [setValidator]="formValidation()!"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="nameEN"
                formControlName="nameEN"
                [invalid]="submitted && scopeForm.get('nameEN')?.invalid!"
                [label]="'common.form.label.nameEN' | translate"
                [setValidator]="formValidation()!"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="dscAE"
                formControlName="dscAE"
                [isTextArea]="true"
                [invalid]="submitted && scopeForm.get('dscAE')?.invalid!"
                [label]="'common.form.label.descriptionAE' | translate"
                [setValidator]="formValidation()!"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="dscEN"
                formControlName="dscEN"
                [isTextArea]="true"
                [invalid]="submitted && scopeForm.get('dscEN')?.invalid!"
                [label]="'common.form.label.descriptionEN' | translate"
                [setValidator]="formValidation()!"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <adaa-form-dropdown
                controlName="layoutId"
                formControlName="layoutId"
                [invalid]="submitted && scopeForm.get('layoutId')?.invalid!"
                [label]="'government_scores.scopes.layout_type' | translate"
                [setValidator]="formValidation()!"
                [options]="layouts()"
            />
        </div>
    </div>
</div>

<adaa-form-action-buttons
    saveButtonTitle="common.form.button.submit"
    [showSaveButton]="pageMode() !== PageMode.view"
    (saveClicked)="submit()"
    (cancelClicked)="goBack()"
/>
